const slider = document.getElementById('slider');
let slideNum = $('.slide').length;
let slideCou = 1;
let leftPos, leftPos2, leftPos3;
let leaveLfetPos;
let goRightPos;
let timer;
let clickFlg = 0;
let slideFlg = 0;

const pickUp = document.querySelector('#pickupSlider');

export function sliderFunc() {
  if (pickUp) {
    if (slideNum == 3) {
      for (let i = 0; i < 3; i++) {
        let clone = slider.children[i].cloneNode(true);
        clone.id = "slide" + (i + 4);
        slider.appendChild(clone);
      }
      slideNum = $('.slide').length;
      lazyload();
    }

    slider.style.width = (500 * slideNum) + 'px';

    const options = {
      root: null,
      threshold: 0,
      rootMargin: "0px 0px -200px"
    };

    const callback = (function (changes) {
      for (let change of changes) {
        if (change.isIntersecting && slideFlg == 0) {
          slideAuto();
          slideFlg = 1;
        }
      }
    });

    const observer = new IntersectionObserver(callback, options);
    observer.observe(pickUp)
  }
}

const slideAuto = function () {
  slide();
  timer = setTimeout(slideAuto, 6000);
}

function slide() {
  if (slideCou < slideNum) {
    clickFlg = 1;
    slideCou++;
    leftPos = -100 * Number(slideCou - 1);
    leftPos2 = 300 - (100 * (slideCou - (slideNum - 2)));
    leftPos3 = 100;
    leaveLfetPos = (-100 * Number(slideCou - 1)) - 200;
    goRightPos = 500 - (100 * Number(slideCou - 2));

    if (slideCou <= slideNum - 2) {
      /***** スライド時間差 *****/
      setTimeout(function () {
        $('#slide' + Number(slideCou)).removeClass('toGoRight').css({
          'opacity': '1',
          'transform': 'translateX(' + leftPos + '%)'
        });
        $('#slide' + Number(slideCou)).removeClass('active');
      }, 100);
      setTimeout(function () {
        $('#slide' + Number(slideCou + 1)).removeClass('toGoRight').css({
          'opacity': '1',
          'transform': 'translateX(' + leftPos + '%)'
        });
        $('#slide' + Number(slideCou + 1)).addClass('active');
      }, 200);
      setTimeout(function () {
        $('#slide' + Number(slideCou + 2)).removeClass('toGoRight').css({
          'opacity': '1',
          'transform': 'translateX(' + leftPos + '%)'
        });
        $('#slide' + Number(slideCou + 2)).removeClass('active');
      }, 300);

    } else if (slideCou == slideNum - 1) {
      /***** スライド時間差 *****/
      setTimeout(function () {
        $('#slide' + Number(slideCou)).removeClass('toGoRight').css({
          'opacity': '1',
          'transform': 'translateX(' + leftPos + '%)'
        });
        $('#slide' + Number(slideCou)).removeClass('active');
      }, 100);
      setTimeout(function () {
        $('#slide' + Number(slideCou + 1)).removeClass('toGoRight').css({
          'opacity': '1',
          'transform': 'translateX(' + leftPos + '%)'
        });
        $('#slide' + Number(slideCou + 1)).addClass('active');
      }, 200);
      setTimeout(function () {
        $('#slide' + Number(slideNum - slideCou)).removeClass('toGoRight').css({
          'opacity': '1',
          'transform': 'translateX(' + leftPos2 + '%)'
        });
        $('#slide' + Number(slideCou + 2)).removeClass('active');
      }, 300);

    } else if (slideCou == slideNum) {
      /***** スライド時間差 *****/
      setTimeout(function () {
        $('#slide' + Number(slideCou)).removeClass('toGoRight').css({
          'opacity': '1',
          'transform': 'translateX(' + leftPos + '%)'
        });
        $('#slide' + Number(slideCou)).removeClass('active');
      }, 100);
      setTimeout(function () {
        $('#slide' + Number(slideNum - (slideCou - 1))).removeClass('toGoRight').css({
          'opacity': '1',
          'transform': 'translateX(' + leftPos2 + '%)'
        });
        $('#slide' + Number(slideNum - (slideCou - 1))).addClass('active');
      }, 200);
      setTimeout(function () {
        $('#slide' + Number(slideNum - (slideCou - 2))).removeClass('toGoRight').css({
          'opacity': '1',
          'transform': 'translateX(' + leftPos3 + '%)'
        });
        $('#slide' + Number(slideNum - (slideCou - 2))).removeClass('active');
      }, 300);

    }

    $('#slide' + Number(slideCou - 1)).addClass('toLeaveLeft');
    $('.toLeaveLeft').css({
      'transform': 'translateX(' + leaveLfetPos + '%)'
    });
    setTimeout(function () {
      $('#slide' + Number(slideCou - 1)).removeClass('toLeaveLeft').addClass('toGoRight');
      $('#slide' + Number(slideCou - 1) + '.toGoRight').css({
        'opacity': '0',
        'transform': 'translateX(' + goRightPos + '%)'
      });

      setTimeout(function () {
        clickFlg = 0;
      }, 1000);
    }, 1000);


  } else if (slideCou == slideNum) {
    clickFlg = 1;
    slideCou = 1;
    leftPos = -100 * Number(slideCou - 1);
    leaveLfetPos = (-100 * Number(slideNum)) - 200;
    goRightPos = 500 - (100 * Number(slideNum - 1));

    /***** スライド時間差 *****/
    setTimeout(function () {
      $('#slide' + Number(slideCou)).removeClass('toGoRight').css({
        'opacity': '1',
        'transform': 'translateX(' + leftPos + '%)'
      });
      $('#slide' + Number(slideCou)).removeClass('active');
    }, 100);
    setTimeout(function () {
      $('#slide' + Number(slideCou + 1)).removeClass('toGoRight').css({
        'opacity': '1',
        'transform': 'translateX(' + leftPos + '%)'
      });
      $('#slide' + Number(slideCou + 1)).addClass('active');
    }, 200);
    setTimeout(function () {
      $('#slide' + Number(slideCou + 2)).removeClass('toGoRight').css({
        'opacity': '1',
        'transform': 'translateX(' + leftPos + '%)'
      });
      $('#slide' + Number(slideCou + 2)).removeClass('active');
    }, 300);

    $('#slide' + Number(slideNum)).addClass('toLeaveLeft');
    $('.toLeaveLeft').css({
      'transform': 'translateX(' + leaveLfetPos + '%)'
    });
    setTimeout(function () {
      $('#slide' + Number(slideNum)).removeClass('toLeaveLeft').addClass('toGoRight');
      $('#slide' + Number(slideNum) + '.toGoRight').css({
        'opacity': '0',
        'transform': 'translateX(' + goRightPos + '%)'
      });

      setTimeout(function () {
        clickFlg = 0;
      }, 1000);
    }, 1000);
  }
}

function slide2() {
  if (slideCou > 1) {
    clickFlg = 1;
    slideCou--;
    leftPos = -100 * Number(slideCou - 1);
    leaveLfetPos = (-100 * Number(slideCou)) - 200;
    goRightPos = 500 - (100 * Number((slideCou + 3) - 2));

    $('#slide' + Number(slideCou)).css({
      'opacity': '0',
      'transform': 'translateX(' + leaveLfetPos + '%)'
    });

    setTimeout(function () {
      if (slideCou < slideNum - 2) {
        /***** スライド時間差 *****/
        setTimeout(function () {
          $('#slide' + Number(slideCou + 2)).removeClass('toGoRight').css({
            'opacity': '1',
            'transform': 'translateX(' + leftPos + '%)'
          });
          $('#slide' + Number(slideCou + 2)).removeClass('active');
        }, 100);
        setTimeout(function () {
          $('#slide' + Number(slideCou + 1)).removeClass('toGoRight').css({
            'opacity': '1',
            'transform': 'translateX(' + leftPos + '%)'
          });
          $('#slide' + Number(slideCou + 1)).addClass('active');
        }, 200);
        setTimeout(function () {
          $('#slide' + Number(slideCou)).removeClass('toGoRight').css({
            'opacity': '1',
            'transform': 'translateX(' + leftPos + '%)'
          });
          $('#slide' + Number(slideCou)).removeClass('active');
        }, 300);

        $('#slide' + Number(slideCou + 3)).css({
          'transform': 'translateX(' + goRightPos + '%)'
        });

      } else if (slideCou == slideNum - 2) {
        /***** スライド時間差 *****/
        setTimeout(function () {
          $('#slide' + Number(slideCou + 2)).removeClass('toGoRight').css({
            'opacity': '1',
            'transform': 'translateX(' + leftPos + '%)'
          });
          $('#slide' + Number(slideCou + 2)).removeClass('active');
        }, 100);
        setTimeout(function () {
          $('#slide' + Number(slideCou + 1)).removeClass('toGoRight').css({
            'opacity': '1',
            'transform': 'translateX(' + leftPos + '%)'
          });
          $('#slide' + Number(slideCou + 1)).addClass('active');
        }, 200);
        setTimeout(function () {
          $('#slide' + Number(slideCou)).removeClass('toGoRight').css({
            'opacity': '1',
            'transform': 'translateX(' + leftPos + '%)'
          });
          $('#slide' + Number(slideCou)).removeClass('active');
        }, 300);

        $('#slide1').css({
          'transform': 'translateX(500%)'
        });

      } else if (slideCou == slideNum - 1) {
        /***** スライド時間差 *****/
        setTimeout(function () {
          $('#slide1').removeClass('toGoRight').css({
            'opacity': '1',
            'transform': 'translateX(200%)'
          });
          $('#slide1').removeClass('active');
        }, 100);
        setTimeout(function () {
          $('#slide' + Number(slideCou + 1)).removeClass('toGoRight').css({
            'opacity': '1',
            'transform': 'translateX(' + leftPos + '%)'
          });
          $('#slide' + Number(slideCou + 1)).addClass('active');
        }, 200);
        setTimeout(function () {
          $('#slide' + Number(slideCou)).removeClass('toGoRight').css({
            'opacity': '1',
            'transform': 'translateX(' + leftPos + '%)'
          });
          $('#slide' + Number(slideCou)).removeClass('active');
        }, 300);

        $('#slide2').css({
          'transform': 'translateX(400%)'
        });
      }

      setTimeout(function () {
        clickFlg = 0;
      }, 1000);
    }, 1000)

  } else if (slideCou == 1) {
    clickFlg = 1;
    slideCou = slideNum;
    leftPos = -100 * Number(slideCou - 1);
    leaveLfetPos = (-100 * Number(slideNum)) - 200;
    goRightPos = 500 - (100 * Number(slideNum - 1));

    $('#slide' + Number(slideCou)).css({
      'opacity': '0',
      'transform': 'translateX(' + leaveLfetPos + '%)'
    });

    setTimeout(function () {
      /***** スライド時間差 *****/
      setTimeout(function () {
        $('#slide2').removeClass('toGoRight').css({
          'opacity': '1',
          'transform': 'translateX(100%)'
        });
        $('#slide2').removeClass('active');
      }, 100);
      setTimeout(function () {
        $('#slide1').removeClass('toGoRight').css({
          'opacity': '1',
          'transform': 'translateX(100%)'
        });
        $('#slide1').addClass('active');
      }, 200);
      setTimeout(function () {
        $('#slide' + Number(slideCou)).removeClass('toGoRight').css({
          'opacity': '1',
          'transform': 'translateX(' + leftPos + '%)'
        });
        $('#slide' + Number(slideCou)).removeClass('active');
      }, 300);

      $('#slide3').css({
        'transform': 'translateX(300%)'
      });

      setTimeout(function () {
        clickFlg = 0;
      }, 1000);
    }, 1000)
  }
}

$('#prevBtn').on('click', function () {
  if (clickFlg == 0) {
    clearTimeout(timer);
    slide2();
    timer = setTimeout(slideAuto, 6000);
  } else {
    return;
  }
});

$('#nextBtn').on('click', function () {
  if (clickFlg == 0) {
    clearTimeout(timer);
    slide();
    timer = setTimeout(slideAuto, 6000);
  } else {
    return;
  }
});
